import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getAssociates } from 'services/AssociatesServices'

export const useGetAssociates = (customerReference: string) => {
  return useQuery({
    queryKey: reactQueryKeys.associates(customerReference),
    queryFn: () => getAssociates(customerReference),
    enabled: !!customerReference,
  })
}
